import React from 'react'
import { Link } from 'react-router-dom';

export default function Footer() 
{
  return (
    <div className='footer-clean'>
    <footer>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-sm-4 col-md-4 item">
                        <h1>Jesmine  Akhter</h1>
                    </div>
                    <div className="col-sm-4 col-md-6 item1 ">
                    <p className='connect'>LET US CONNECT</p>
                       <a href="https://www.linkedin.com/in/jesmine-akhter-3ab991247" target="_blank"><i className="fab fa-linkedin-in social"></i></a>
                       <a href="https://github.com/JA-26-01" target="_blank"><i className="fab fa-github social"></i></a>
                       <a  href="https://www.behance.net/jesmine_akhter" target="_blank"><i className="fab fa-behance social"></i></a>
                    <p className="copyright">Jesmine Akhter © 2023. All rights reserved</p>
                    </div>
                    
                    <div className="col-sm-4 col-md-2 item3">
                        <h3>EXPLORE</h3>
                        <ul>
                            <li><Link className="nav-link active text-white" aria-current="page" to="/home">Home</Link></li>
                            <li><Link className="nav-link text-white" to="/work">Work</Link></li>
                            <li><Link className="nav-link text-white" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
   </div>
  )
}
